import { Box } from "@mui/material";
import { motion } from "framer-motion";

/** Shared MotionBox — single definition instead of duplicating across 17+ files */
export const MotionBox = motion.create(Box);

/** Fade-in-up animation variant — the most common entrance animation */
export const fadeInUp = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
} as const;

/** Hover/tap scale presets for interactive elements */
export const hoverScale = {
  /** Small scale-up for icons and nav items */
  scaleSm: { whileHover: { scale: 1.1 } },
  /** Larger scale-up with tap feedback for buttons and cards */
  scaleLg: { whileHover: { scale: 1.05 }, whileTap: { scale: 0.95 } },
} as const;
